export { NgxDataTableConfig } from './ngx-datatable-config';
export { TableComponent } from './table.component';
export { TableConfig } from './table-config';
export { TableModule } from './table.module';
